// src/components/CompanyVisionSection.js
import React from "react";
import styles from "../styles/CompanyVisionSection.module.css";
// 필요하다면 비전 관련 아이콘이나 이미지 import
// import ecoIcon from '../assets/eco-icon.png';
// import visionGraphic from '../assets/vision-graphic.png';

function CompanyVisionSection() {
  return (
    <div className={styles.visionContainer}>
      {/* ♻️ 아이콘을 별도의 div로 감싸 스타일링 유연성 확보 */}
      <div className={styles.iconWrapper}>
        <span role="img" aria-label="recycle" className={styles.mainIcon}>
          ♻️
        </span>
      </div>

      {/* 메인 비전 타이틀 */}
      <h2 className={styles.mainTitle}>지속가능한 도시를 위한 첫걸음</h2>

      {/* 서브 타이틀 또는 강조 문구 */}
      <p className={styles.subTitle}>함께해주세요</p>

      {/* 비전 설명 문구 */}
      <div className={styles.descriptionWrapper}>
        <p className={styles.descriptionText}>
          이코픽과 들어드림은 재활용 수거의 혁신을 이끌어갑니다.
        </p>
        <p className={styles.descriptionText}>
          데이터 기반, 지역 밀착형, 사용자 중심 플랫폼으로 <br />
          누구나 쉽게 참여하고, 누구나 보상받는 수거 생태계를 만들어갑니다.
        </p>
      </div>

      {/* 필요하다면 비전과 관련된 이미지나 그래프 추가 */}
      {/* <img src={visionGraphic} alt="회사 비전 그래픽" className={styles.visionGraphic} /> */}
    </div>
  );
}

export default CompanyVisionSection;
